import CurrencyFormatter from "currency-formatter";

export default class ForecastedGWC {
  constructor({
    nonCashWorkingCapitalPercentageRevenue = 0,
    forecastRevenue = 0,
    growthRate = 1,
    analystNote = ""
  }) {
    this.nonCashWorkingCapitalPercentageRevenue = nonCashWorkingCapitalPercentageRevenue
    this.forecastRevenue = forecastRevenue
    this.growthRate = growthRate
    this.analystNote = analystNote
  }

  get nonCashWorkingCapitalPercentageRevenueFloat() {
    return CurrencyFormatter.unformat(this.nonCashWorkingCapitalPercentageRevenue, { code: "USD" })
  }

  get futureNonCashWorkingCapitalAmount() {
    return this.nonCashWorkingCapitalAmount * this.growthRate
  }

  get forecastedRevenueFloat() {
    return CurrencyFormatter.unformat(this.forecastRevenue, { code: "USD" })
  }

  get requiredAnnualInvestment() {
    return this.futureNonCashWorkingCapitalAmount - this.nonCashWorkingCapitalAmount
  }

  get nonCashWorkingCapitalAmount() {
    return this.nonCashWorkingCapitalPercentageRevenueFloat * (this.forecastedRevenueFloat / 100)
  }

  get nonCashWorkingCapitalAmountFormatted() {
    return CurrencyFormatter.format(this.nonCashWorkingCapitalAmount, { code: "USD" })
  }

  get forecastedRevenueFormatted() {
    return CurrencyFormatter.format(this.forecastRevenue, { code: "USD" })
  }

  get futureNonCashWorkingCapitalAmountFormatted() {
    return CurrencyFormatter.format(this.futureNonCashWorkingCapitalAmount, { code: "USD" })
  }

  get requiredAnnualInvestmentFormatted() {
    return CurrencyFormatter.format(this.requiredAnnualInvestment, { code: "USD" })
  }
}